import Vue from 'vue'

import Vuex from 'vuex'
Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
      items: [],
      homepage_data: {},
      profiles: {},
      restrictions : [],
      stickers : [],
      user : {},
    },
    mutations: {
        update_item (state, item) {
          
          state.items[item.id] = item; 
        },
        open_search (state) {
        
          state.is_search_opened = true;
        }
    },
    getters: {
        
        get_item: (state) => (id) => {
            //return getters.doneTodos.length

            return state.items[id]; 


          }
      }
      
  });
 // store.commit('update_article', {} );